import { formatDistanceToNowStrict as fnsformatDistanceToNowStrict } from 'date-fns';

import locales from 'src/constants/locales';

const formatDistanceToNowStrict = (timeStamp?: string, lang?: SupportedLangs) => {
    if (timeStamp && lang) {
        return fnsformatDistanceToNowStrict(new Date(timeStamp), {
            locale: locales[lang],
        });
    } else return '';
};

export default formatDistanceToNowStrict;
